export enum IconNames {
  ice_mobilbytte = 'ice_mobilbytte',
  ice_calendar = 'ice_calendar',
  ice_cart = 'ice_cart',
  ice_forward = 'ice_forward',
  ice_info = 'ice_info',
  ice_invoice = 'ice_invoice',
  ice_ruter = 'ice_ruter',
  ice_simcard = 'ice_simcard',
  ice_twinsim = 'ice_twinsim',
  ice_user = 'ice_user',
  ice_warning = 'ice_warning',
  ice_shop = 'ice_shop',
  ice_document = 'ice_document',
  ice_phone = 'ice_phone',
  ice_circle_trade_in_mobile = 'ice_circle_trade_in_mobile',
  ice_delivery = 'ice_delivery',
  ice_close = 'ice_close',
  ice_close_thick = 'ice_close_thick',
  ice_add = 'ice_add',
  ice_search = 'ice_search',
  ice_business = 'ice_business',
  ice_chevron_right = 'ice_chevron_right',
  ice_chevron_down = 'ice_chevron_down',
  ice_chevron_up = 'ice_chevron_up',
  ice_chevron_left = 'ice_chevron_left',
  ice_chevron_down_narrow = 'ice_chevron_down_narrow',
  ice_hamburger = 'ice_hamburger',
  ice_menu_close = 'ice_menu_close',
  ice_time = 'ice_time',
  ice_crystal = 'ice_crystal',
  ice_customer_service = 'ice_customer_service',
  ice_add_customer = 'ice_add_customer',
  ice_message = 'ice_message',
  ice_tick = 'ice_tick',
  ice_worried = 'ice_worried',
  ice_kissing = 'ice_kissing',
  ice_arrow_left = 'ice_arrow_left',
  ice_arrow_right = 'ice_arrow_right',
  ice_circle_cross = 'ice_circle_cross',
  ice_circle_tick = 'ice_circle_tick',
  ice_circle_wave = 'ice_circle_wave',
  ice_eye_crossed = 'ice_eye_crossed',
  ice_junior = 'ice_junior',
  ice_happy = 'ice_happy',
  ice_laughing = 'ice_laughing',
  ice_light_bulb = 'ice_light_bulb',
  ice_nervous = 'ice_nervous',
  ice_pensive = 'ice_pensive',
  ice_mbb = 'ice_mbb',
  ice_thumbs_up = 'ice_thumbs_up',
  ice_thumbs_down = 'ice_thumbs_down',
  ice_hearteyes = 'ice_hearteyes',
  ice_unhappy = 'ice_unhappy',
  ice_gaming = 'ice_gaming',
  ice_bank_id = 'ice_bank_id',
  ice_power = 'ice_power',
  ice_team = 'ice_team',
  ice_invoicing = 'ice_invoicing',
  ice_family = 'ice_family',
  ice_trygg = 'ice_trygg',
  ice_trygg_illustration = 'ice_trygg_illustration',
  ice_edit = 'ice_edit',
  ice_trophy = 'ice_trophy',
  ice_arrow_down = 'ice_arrow_down',
  ice_mobile_insurance = 'ice_mobile_insurance',
  ice_copy = 'ice_copy',
  ice_email = 'ice_email',
  ice_telephone = 'ice_telephone',
  ice_phone_trade_in = 'ice_phone_trade_in',
  ice_clock = 'ice_clock',
  ice_waiting = 'ice_waiting',
  ice_pin = 'ice_pin',
  ice_checkmark = 'ice_checkmark',
  ice_checkmark_circle = 'ice_checkmark_circle',
  ice_checkmark_circle_outline = 'ice_checkmark_circle_outline',
  ice_gift = 'ice_gift',
  ice_paper_plane = 'ice_paper_plane',
  ice_external_link = 'ice_external_link',
  ice_hand_wave = 'ice_hand_wave',
  ice_cheap = 'ice_cheap',
  ice_save = 'ice_save',
  ice_bullet_list = 'ice_bullet_list',
  ice_settings = 'ice_settings',
  ice_moon = 'ice_moon',
  ice_moon_filled = 'ice_moon_filled',
  ice_praise = 'ice_praise',
  ice_house = 'ice_house',
  ice_log_out = 'ice_log_out',
  ice_chat = 'ice_chat',
  ice_satisfied = 'ice_satisfied',
  ice_tick_fat = 'ice_tick_fat',
  ice_recycle = 'ice_recycle',
  ice_info_filled = 'ice_info_filled',
  ice_trash = 'ice_trash',
  ice_refresh = 'ice_refresh',
  ice_security = 'ice_security',
  ice_shipping_box = 'ice_shipping_box',
  ice_bell = 'ice_bell',
  ice_pennant = 'ice_pennant',
  ice_nettvern = 'ice_nettvern',
}
